export default __webpack_public_path__ + "media/verify_late_user_account_email/title_locale_it-bfedad3c.png";